import { GoogleMap, withGoogleMap, withScriptjs } from "react-google-maps";
import * as React from "react";
import { compose, withProps } from "recompose";
import Marker from "react-google-maps/lib/components/Marker";
import googleMaps from "../../api/googleMaps";
import DirectionsRenderer from "react-google-maps/lib/components/DirectionsRenderer";
import { FormControl, Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import StandaloneSearchBox from "react-google-maps/lib/components/places/StandaloneSearchBox";
import MoneyLabel from "../MoneyLabel";
import NumberFormat from "react-number-format";
import DirectionsResult = google.maps.DirectionsResult;
import PlaceResult = google.maps.places.PlaceResult;
import DirectionsLeg = google.maps.DirectionsLeg;
import DirectionsRoute = google.maps.DirectionsRoute;
import LatLngBounds = google.maps.LatLngBounds;
import { ConfigData } from "../../config";
import { getApi } from "../../api/ApiProvider";
import { BranchSelector, BranchData } from "../BranchSelector";
import { RaceData } from "./AddDelivery";
import { Driver, Location } from "../../api/model";
import { Star, StarBorder } from "@material-ui/icons";
import { ClientActions } from "../../store/client";

// import { ClientLocationMng } from '../ClientLocationMng';

export class Dot {
  lat: any;
  lng: any;

  constructor(latitude: number, longitude: number) {
    this.lat = latitude;
    this.lng = longitude;
  }
}

export interface RouteData {
  origin?: Dot;
  originStreet?: string;
  destiny?: Dot;
  destinyStreet?: string;

  distance?: number;
  price?: number;
  duration?: string;
  fullData?: DirectionsResult;
  route?: DirectionsRoute;
  leg?: DirectionsLeg;
  searchBounds?: LatLngBounds;

  // Client document
  clientDocument?: string;
  clientLocations?: LocationData[];
  selectedClientLocationId?: string | undefined;
  selectedClientLocation?: LocationData;
  client?: any;

  // Branch data used as origin
  selectedBranch?: BranchData;
  branchList?: BranchData[] | undefined;

  destinyObject?: Location | undefined;
  driver?: number;
  amount?: number;
}

export interface RouteSelectorProps {
  data?: RouteData;
  raceData?: RaceData;
  config: ConfigData;
  companyId: number;
  defaultChange: (l: any) => void;
  onNewData: (data: RouteData) => void;
}

type MarkerType = "origin" | "destiny";

interface RouteSelectorState {
  data: RouteData;
  line?: string;
  center: Dot;
  priceDeliveryKm: number;
  newLocation: boolean;
  whatsappLink: string;
  drivers: any[];
  driversFilters: any[];
}

interface MapProps {
  zoom: number;
  center: Dot;
  origin?: Dot;
  destiny?: Dot;
  directions: any;

  handleOnClick(e: google.maps.MouseEvent | google.maps.IconMouseEvent): void;

  handleDragEnd(whichOne: string): (e: google.maps.MouseEvent) => void;
}

export interface LocationData {
  id: number;
  lat: number;
  lng: number;

  street1: string;
  defaultLocation: boolean;
  client: {
    user: { name: string; email: string };
    phone: string;
  };
}

const RouteMap: React.SFC<MapProps> = (props: MapProps) => {
  const {
    center,
    zoom,
    origin,
    destiny,
    handleDragEnd,
    handleOnClick,
    directions,
  } = props;
  return (
    <GoogleMap defaultZoom={zoom} center={center} onClick={handleOnClick}>
      {origin && (
        <Marker
          draggable
          onDragEnd={handleDragEnd("origin")}
          position={origin}
          label={{ text: "O", color: "white" }}
        />
      )}
      {destiny && (
        <Marker
          draggable
          onDragEnd={handleDragEnd("destiny")}
          position={destiny}
          label={{ text: "D", color: "white" }}
        />
      )}

      {directions && (
        <DirectionsRenderer
          directions={directions}
          defaultOptions={{ suppressMarkers: true }}
        />
      )}
    </GoogleMap>
  );
};

const EnhancedMap = compose<MapProps, MapProps>(
  withProps({
    containerElement: <div style={{ height: "100%" }} />,
    mapElement: <div style={{ height: "100%" }} />,
  }),
  withGoogleMap
)(RouteMap);

class DeliveryRouteSelector extends React.Component<
  RouteSelectorProps,
  RouteSelectorState
> {
  refOrigin: StandaloneSearchBox;
  refDestiny: StandaloneSearchBox;

  constructor(props: RouteSelectorProps) {
    super(props);
    this.state = {
      data: {
        originStreet: props.config.races.predefinedFrom ? "Origen" : "",
        destinyStreet: "",
        clientDocument: "",
        clientLocations: [],
        destinyObject: {
          lat: 0,
          lng: 0,
          street1: "",
          number: undefined,
          observation: "",
          street2: "",
        },
        ...props.data,
      },
      center: props.config.maps.startingLocation,
      newLocation: false,
      whatsappLink: "",
      drivers: [],
      driversFilters: [],
      priceDeliveryKm: 0,
    };

    this.onOriginMounted = this.onOriginMounted.bind(this);
    this.onDestinyMounted = this.onDestinyMounted.bind(this);

    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
    this.fireNewDataEvent = this.fireNewDataEvent.bind(this);

    this.requestNewDirections = this.requestNewDirections.bind(this);
    this.getRouteDescription = this.getRouteDescription.bind(this);
    this.handleKeyPressInDocument = this.handleKeyPressInDocument.bind(this);
    this.onChangeClientLocationSelect =
      this.onChangeClientLocationSelect.bind(this);
    this.onChangeBranchSelector = this.onChangeBranchSelector.bind(this);

    this.onChangeClientLocationSelect2 =
      this.onChangeClientLocationSelect2.bind(this);

    this.checkValidGMapsLink = this.checkValidGMapsLink.bind(this);
    this.checkValidWhatsappLocationLink =
      this.checkValidWhatsappLocationLink.bind(this);
    this.onMapLinkChange = this.onMapLinkChange.bind(this);
    this.parseLocationLink = this.parseLocationLink.bind(this);

    // If client isn't new
    if (this.props.raceData!.user && !this.props.raceData!.newClient) {
      console.log("cliente is not new");
      this.getLocationsByClientDocument(this.props.raceData!.user.document);
    }
  }

  getDrivers() {
    getApi()
      .driver()
      .listActiveByAdmin()
      .then((data: Driver[]) => {
        const filterDrivers = data.filter(
          (d) => d.branch.id === this.state.data.branchList[0].id
        );
        this.setState({ drivers: data, driversFilters: filterDrivers });
      });
  }

  getCompany() {
    getApi()
      .company()
      .getCurrent(this.props.companyId)
      .then((data) => {
        this.setState({
          priceDeliveryKm: data.priceDelivery,
        });
      });
  }

  handleOnClick(args: google.maps.MouseEvent | google.maps.IconMouseEvent) {
    if (!this.state.data.origin) {
      this.setState({
        ...this.state,
        data: {
          ...this.state.data,
          origin: new Dot(args.latLng.lat(), args.latLng.lng()),
        },
      });
      this.fireNewDataEvent(true);
      return;
    }

    if (!this.state.data.destiny) {
      this.setState({
        ...this.state,
        data: {
          ...this.state.data,
          destiny: new Dot(args.latLng.lat(), args.latLng.lng()),
        },
      });
      this.fireNewDataEvent(true);
      return;
    }
  }

  async requestNewDirections(forceRename: boolean) {
    if (this.state.data.origin && this.state.data.destiny) {
      try {
        const data: DirectionsResult = await googleMaps.getDirections(
          this.state.data.origin,
          this.state.data.destiny,
          this.props.config.maps.region
        );
        this.handleDirectionsData(data, forceRename);
        console.log("se pidieron nuevas direcciones:" + data);
      } catch (err) {
        console.log(err);
        this.setState({
          data: {
            ...this.state.data,
            distance: undefined,
            duration: undefined,
            fullData: undefined,
            price: undefined,
          },
        });
      }
    }
  }

  handleDirectionsData(data: DirectionsResult, forceNewPosition = true) {
    const route = data && data.routes && data.routes[0];

    const leg = route && route.legs && route.legs[0] && route.legs[0];

    if (!leg) {
      return;
    }

    const priceDeliveryKm = this.state.priceDeliveryKm;

    this.setState({
      data: {
        ...this.state.data,
        originStreet: forceNewPosition
          ? leg.start_address
          : this.state.data.originStreet || leg.start_address,
        destinyStreet: forceNewPosition
          ? leg.end_address
          : this.state.data.destinyStreet || leg.end_address,
        fullData: data,
        leg: leg,
        route: route,
        distance: leg.distance.value,
        duration: leg.duration.text,
        amount: Math.ceil((leg.distance.value / 1000) * priceDeliveryKm),
        price: (leg.distance.value / 1000) * priceDeliveryKm,
      },
    });
  }

  getRouteDescription() {
    const data = this.state.data;
    if (!data.fullData) {
      return (
        <Typography variant="caption" style={{ paddingTop: 20 }}>
          Costo según la distancia entre la sucursal y el destino.
        </Typography>
      );
    }

    return (
      <Typography variant="caption">
        El viaje es de:{" "}
        <NumberFormat
          value={(data.distance || 0) / 1000}
          suffix={"Km."}
          displayType={"text"}
          decimalScale={1}
        />{" "}
        , y costará aproximadamente <MoneyLabel amount={data.price} />.
      </Typography>
    );
  }

  handleDragEnd(marker: MarkerType) {
    return (e: google.maps.MouseEvent) => {
      this.setState({
        data: {
          ...this.state.data,
          [marker]: new Dot(e.latLng.lat(), e.latLng.lng()),
        },
      });
      this.fireNewDataEvent(true);
    };
  }

  fireNewDataEvent(forceRename: boolean) {
    if (this.state.data.origin && this.state.data.destiny) {
      this.requestNewDirections(forceRename).then(() => {
        this.props.onNewData(this.state.data);
      });
    }
  }

  setNewPlace(ref: StandaloneSearchBox, type: MarkerType) {
    const places: PlaceResult[] = ref.getPlaces();
    const bounds = new google.maps.LatLngBounds();

    places.forEach((place: PlaceResult | undefined) => {
      if (place && place.geometry && place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        if (place && place.geometry && place.geometry.location) {
          bounds.extend(place.geometry.location);
        }
      }
    });

    const nextMarkers = places.map((place: PlaceResult) => {
      if (place && place.geometry && place.geometry.location) {
        return {
          position: place.geometry.location,
        };
      } else {
        return { position: this.state.center };
      }
    });
    const nextCenter =
      (nextMarkers && nextMarkers[0] && nextMarkers[0].position) ||
      this.state.center;
    const centerDot = new Dot(nextCenter.lat(), nextCenter.lng());

    this.setState({
      data: {
        ...this.state.data,
        [type]: centerDot,
      },
      center: centerDot,
    });
    this.fireNewDataEvent(true);
  }

  onPlaceSelected(type: MarkerType) {
    return () => {
      this.setNewPlace(
        type === "origin" ? this.refOrigin : this.refDestiny,
        type
      );
    };
  }

  onOriginMounted(ref: any) {
    this.refOrigin = ref;
    // this.getSearchRegionBounds();
    this.getBranchList();
    this.getCompany();

    setTimeout(() => {
      this.getDrivers();
    }, 2000);
  }

  // componentDidMount() {}

  onDestinyMounted(ref: StandaloneSearchBox) {
    this.refDestiny = ref;
  }

  async getSearchRegionBounds() {
    const bounds: LatLngBounds = await googleMaps.getGeoCodeBounds(
      this.props.config.maps.region
    );
    this.setState({
      data: {
        ...this.state.data,
        searchBounds: bounds,
      },
    });
  }

  getLocationsByClientDocument(document: string) {
    getApi()
      .admin()
      .clientLocationByDocument(document)
      .then((data) => {
        const defaultDataLocation = data.filter(
          (d: any) => d.defaultLocation === true
        );
        this.setState({
          data: {
            ...this.state.data,
            clientLocations: data,
            selectedClientLocationId:
              defaultDataLocation[0] && defaultDataLocation[0].id
                ? defaultDataLocation[0].id
                : "",
          },
        });
        if (defaultDataLocation[0] && defaultDataLocation[0].id) {
          this.onChangeClientLocationSelect(defaultDataLocation[0].id);
        }
      })
      .catch((error) => {
        this.setState({
          data: {
            ...this.state.data,
            clientLocations: undefined,
            selectedClientLocation: undefined,
            selectedClientLocationId: undefined,
          },
        });
      });
  }

  handleKeyPressInDocument(e: React.KeyboardEvent<any>) {
    if (e.key === "Enter") {
      if (this.state.data.clientDocument) {
        this.getLocationsByClientDocument(this.state.data.clientDocument);
      }
    }
  }

  onChangeClientLocationSelect(value: any) {
    if (value === 0) {
      this.setState(
        {
          data: {
            ...this.state.data,
            selectedClientLocationId: "",
            selectedClientLocation: null,
            destinyStreet: "",
            destiny: null,
            destinyObject: {
              lat: 0,
              lng: 0,
              street1: "",
              number: undefined,
              observation: "",
              street2: "",
            },
          },
          center: null,
          newLocation: true,
        },
        () => this.fireNewDataEvent(true)
      );
      return;
    }
    const location = this.getClientLocationByName(value);
    if (location) {
      setTimeout(() => {
        this.setState(
          {
            data: {
              ...this.state.data,
              selectedClientLocationId: value,
              selectedClientLocation: location,
              destinyStreet: location.street1,
              destiny: new Dot(location.lat, location.lng),
              destinyObject: location,
            },
            center: new Dot(location.lat, location.lng),
            newLocation: false,
          },
          () => this.fireNewDataEvent(true)
        );
      }, 500);
    }

    console.log(
      `selectedClientLocation--> ${this.state.data.selectedClientLocation}`
    );
  }

  getClientLocationByName(id: string): LocationData | undefined {
    const nid = Number(id);
    if (this.state.data.clientLocations) {
      const loc = this.state.data.clientLocations.find((l) => l.id === nid);

      return loc ? loc : undefined;
    }
    return undefined;
  }

  getBranchList() {
    getApi()
      .branch()
      .listAllBranchesAdmin()
      .then((data) => {
        this.setState(
          {
            data: {
              ...this.state.data,
              branchList: data,
            },
          },
          () => {
            // default first branch selection
            this.setBranch(0);
          }
        );
      });
  }

  onChangeBranchSelector(e: React.ChangeEvent<any>) {
    const idx = +e.target.value;
    this.setBranch(idx);
    const filterDrivers = this.state.drivers.filter(
      (d) =>
        d.branch.id === this.state.data.branchList[idx].id &&
        d.user.state === "ACTIVE"
    );
    this.setState({ driversFilters: filterDrivers });
  }

  setBranch(idx: number) {
    const branch = this.state.data.branchList
      ? this.state.data.branchList[idx]
      : undefined;
    const origin = this.state.data.origin;
    console.log(idx);
    this.setState({
      data: {
        ...this.state.data,
        selectedBranch: branch,
        origin: branch
          ? new Dot(branch.location.lat, branch.location.lng)
          : origin,
      },
    });
  }

  onChangeClientLocationSelect2(index: number) {
    console.log(index);
    if (index < 0) {
      this.setState({
        data: {
          ...this.state.data,
          selectedClientLocation: undefined,
          selectedClientLocationId: undefined,
        },
      });
    }

    const location =
      this.state.data.clientLocations && this.state.data.clientLocations[index];
    if (location && index >= 0) {
      this.setState(
        {
          data: {
            ...this.state.data,
            selectedClientLocationId: index.toString(),
            selectedClientLocation: location,
            destinyStreet: location.street1,
            destiny: new Dot(location.lat, location.lng),
          },
          center: new Dot(location.lat, location.lng),
        },
        () => this.fireNewDataEvent(true)
      );
    }
  }

  checkValidGMapsLink(link: string): boolean {
    return (
      link.includes("@") &&
      /@(\+|-)(\d+)(\.?)(\d+)(%2C|,)(\+|-)(\d+)(\.?)(\d+)(%2C|,)(\d+)(\.?)(\d+)z/.test(
        link
      )
    );
  }

  checkValidWhatsappLocationLink(link: string): boolean {
    return (
      link.includes("q=") &&
      /(\+|-)(\d+)\.(\d+)(%2C|,)(\+|-)(\d+)\.(\d+)&/.test(link.split("q=")[1])
    );
  }

  parseLocationLink(link: string, type: "GMAPS" | "WHATSAPP"): string {
    console.log(type);
    if (type === "WHATSAPP") {
      const match = link.match(
        /(\+|-)(\d+)\.(\d+)(%2C|,)(\+|-)(\d+)\.(\d+)&/
      ) || [""];
      return match[0].replace("&", "").replace("%2C", ",");
    }
    return "";
  }

  onMapLinkChange(e: React.ChangeEvent<any>) {
    const link: string = e.target.value;
    this.setState({ whatsappLink: link });
    const isValidGMapsLink = this.checkValidGMapsLink(link);
    const isValidWhatsappLocationLink =
      this.checkValidWhatsappLocationLink(link);
    const type = isValidGMapsLink ? "GMAPS" : "WHATSAPP";
    if (
      link.includes("maps") &&
      (isValidGMapsLink || isValidWhatsappLocationLink)
    ) {
      const parsed = this.parseLocationLink(link, type);
      if (parsed.length < 1) {
        return;
      }
      const [lat, lng] = parsed
        .split(",")
        .map((coord: string) => Number(coord));
      console.log(lat, lng);
      this.setState({
        data: {
          ...this.state.data,
          destiny: {
            lat: lat,
            lng: lng,
          },
        },
      });
      setTimeout(() => this.fireNewDataEvent(true), 500);
      setTimeout(() => {
        this.updateNewLocation(this.state.data.destinyStreet, "street1");
      }, 1000);
    }
  }

  updateNewLocation(value: any, property: string) {
    const location = { ...this.state.data.destinyObject };
    location[property] = property === "number" ? Number(value) : value;
    this.setState({
      data: {
        ...this.state.data,
        destinyObject: location as Location,
      },
    });
  }

  changeDriver(id: string) {
    console.log("driver", id);
    if (id !== "0") {
      const driverId = Number(id);
      this.setState({ data: { ...this.state.data, driver: driverId } });
      this.props.onNewData(this.state.data);
    }
  }

  defaultChange(id: any) {
    const idLocation = id;
    const alterLocations = this.state.data.clientLocations.map((l: any) => {
      if (l.id === idLocation) {
        l.defaultLocation = true;
        return { ...l };
      } else {
        l.defaultLocation = false;
        return { ...l };
      }
    });

    alterLocations.map((l: any) => this.props.defaultChange(l));
  }

  render() {
    const defaultLocationSelect = {
      id: 0,
      lat: 0,
      lng: 0,
      street1: "",
      defaultLocation: false,
      client: {
        user: { name: "", email: "" },
        phone: "",
      },
    };
    let clientLocations: LocationData[] = [defaultLocationSelect];

    if (
      this.state.data.clientLocations &&
      this.state.data.clientLocations.length > 0
    ) {
      clientLocations = this.state.data.clientLocations;
    }
    const newLocation =
      this.state.newLocation || this.state.data.clientLocations.length === 0;
    return (
      <Grid container>
        <Grid item md={12}>
          <Typography
            variant="caption"
            style={{ textAlign: "center", color: "#999" }}
          >
            <p>
              Seleccione la sucursal de origen y complete los datos del destino
              o seleccione el mismo en el mapa.
            </p>
          </Typography>
        </Grid>
        <Grid item md={4} style={{ paddingRight: 10 }}>
          <h4>Sucursal</h4>

          <BranchSelector
            branchList={this.state.data.branchList}
            onChange={this.onChangeBranchSelector}
            ref={this.onOriginMounted}
            style={{ width: "90%" }}
          />

          <form noValidate autoComplete="off">
            <br />
            <h4>Dirección de entrega</h4>
            <div>
              {(this.state.data.selectedClientLocation &&
                this.state.data.selectedClientLocation.client.user.name) ||
                ""}
            </div>
            {this.state.data.clientLocations &&
            this.state.data.clientLocations.length > 0 ? (
              <Select
                style={{ width: "90%" }}
                value={
                  this.state.data.selectedClientLocationId
                    ? this.state.data.selectedClientLocationId
                    : "0"
                }
                inputProps={{
                  name: "location",
                  id: "clientLocationClient",
                }}
                onChange={(e) =>
                  this.onChangeClientLocationSelect(e.target.value)
                }
              >
                <MenuItem value={0}>Nueva dirección</MenuItem>
                {clientLocations.map((location, index) => (
                  <MenuItem key={index} value={location.id}>
                    {location.defaultLocation ? (
                      <Star style={{ color: "#ff0", borderColor: "#000" }} />
                    ) : (
                      <StarBorder
                        onClick={() => this.defaultChange(location.id)}
                      />
                    )}
                    &nbsp; &nbsp;
                    {location.street1
                      ? `${location.street1}`
                      : `Dirección # ${location.id}`}
                  </MenuItem>
                ))}
              </Select>
            ) : (
              <h6>Nueva dirección</h6>
            )}

            {/* {(this.props.raceData!.newClient ||
              this.state.newLocation ||
              (this.state.data.clientLocations &&
                this.state.data.clientLocations.length === 0)) && ( */}
            <div>
              <TextField
                id="street1"
                disabled={!newLocation}
                label="Calle Principal"
                value={this.state.data.destinyObject!.street1 || ""}
                style={{
                  width: "90%",
                }}
                margin="normal"
                placeholder="Calle Principal"
                onChange={(e) =>
                  this.updateNewLocation(e.target.value, "street1")
                }
                onBlur={() => this.props.onNewData(this.state.data)}
              />
              <TextField
                id="street2"
                label="Calle Secundaria"
                disabled={!newLocation}
                value={this.state.data.destinyObject!.street2 || ""}
                style={{
                  width: "90%",
                }}
                margin="normal"
                placeholder="Calle Secundaria"
                onChange={(e) =>
                  this.updateNewLocation(e.target.value, "street2")
                }
                onBlur={() => this.props.onNewData(this.state.data)}
              />
              <TextField
                id="number"
                disabled={!newLocation}
                label="Nro. Casa"
                value={this.state.data.destinyObject!.number || ""}
                style={{
                  width: "90%",
                }}
                margin="normal"
                placeholder="Número"
                onChange={(e) =>
                  this.updateNewLocation(e.target.value, "number")
                }
                onBlur={() => this.props.onNewData(this.state.data)}
              />
              <TextField
                id="observation"
                disabled={!newLocation}
                label="Observación"
                value={this.state.data.destinyObject!.observation || ""}
                style={{
                  width: "90%",
                }}
                margin="normal"
                placeholder="Observación"
                onChange={(e) =>
                  this.updateNewLocation(e.target.value, "observation")
                }
                onBlur={() => this.props.onNewData(this.state.data)}
              />
            </div>

            {/* <ClientLocationMng
                            locationList={this.state.data.clientLocations}
                            clientDocument={this.state.data.clientDocument}
                            onChange={this.onChangeClientLocationSelect2}
                        /> */}
            <br />
            <br />
            <hr />
            <p>Buscar por link:</p>
            <TextField
              id="whatsapp"
              label="Link ubicación Whatsapp"
              onChange={this.onMapLinkChange}
              style={{
                width: "90%",
              }}
              onBlur={() => this.props.onNewData(this.state.data)}
            />

            <br />
          </form>
          <br />
          <hr />
          <h4>Chofer:</h4>
          {this.state.driversFilters.length > 0 ? (
            <>
              <FormControl style={{ width: "90%" }}>
                <Select
                  value={
                    this.state.data.driver !== undefined
                      ? this.state.data.driver
                      : "0"
                  }
                  inputProps={{
                    name: "branch-selector",
                    id: "branchSelector",
                  }}
                  onChange={(e) => this.changeDriver(e.target.value)}
                  style={{ width: "100%" }}
                  onBlur={() => this.props.onNewData(this.state.data)}
                >
                  {this.state.driversFilters.map((driver, index) => (
                    <MenuItem key={index} value={driver.id}>
                      {driver.branch.name} / {driver.user.name}{" "}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <hr />
            </>
          ) : (
            <>
              <h6>La sucursal no cuenta con choferes</h6>
              <br />
            </>
          )}
          <h4>Costo:</h4>
          <TextField
            id="amount"
            label="Costo de envio"
            type="number"
            value={this.state.data.amount || ""}
            onChange={(e) =>
              this.setState({
                data: { ...this.state.data, amount: Number(e.target.value) },
              })
            }
            onBlur={() => this.props.onNewData(this.state.data)}
            style={{
              width: "90%",
            }}
          />
        </Grid>
        <Grid item md={8}>
          <StandaloneSearchBox
            ref={this.onDestinyMounted}
            bounds={this.state.data.searchBounds}
            onPlacesChanged={this.onPlaceSelected("destiny")}
          >
            <TextField
              id="destiny"
              label="Buscar una dirección en el mapa"
              value={this.state.data.destinyStreet}
              onChange={(e) =>
                this.setState({
                  data: {
                    ...this.state.data,
                    destinyStreet: e.target.value,
                  },
                })
              }
              style={{
                width: "100%",
              }}
              margin="normal"
              placeholder="Ingrese una dirección, ciudad"
            />
          </StandaloneSearchBox>
          <EnhancedMap
            center={this.state.center}
            zoom={this.props.config.maps.startingLocation.zoom}
            destiny={this.state.data.destiny}
            origin={this.state.data.origin}
            directions={this.state.data.fullData}
            handleDragEnd={this.handleDragEnd}
            handleOnClick={this.handleOnClick}
          ></EnhancedMap>
          <br />
        </Grid>

        <Grid item md={12}>
          {this.getRouteDescription()}
        </Grid>
        <Grid item md={12} style={{ paddingTop: 50 }}>
          <br />
          <hr />
        </Grid>
      </Grid>
    );
  }
}

export default compose<any, RouteSelectorProps>(
  withProps((props: RouteSelectorProps) => {
    return {
      googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${props.config.maps.key}`,
      loadingElement: <div style={{ minHeight: "100%" }} />,
    };
  }),
  withScriptjs
)(DeliveryRouteSelector);



// WEBPACK FOOTER //
// ./src/components/delivery/DeliveryRouteSelector.tsx